<template>
    <div class="title">
        <h3>Select Route</h3>
        <p>User: {{ username }}</p>
    </div>
    <div class="titleButton">
        <button class="buttonLogOut" @click="logOff">BACK</button>
    </div>
    <div class="options">
        <div class="DefualtOption">
            <button style="width: 33%; border-right: 5px white solid;" @click="selectTicket()">Ticket Selling</button>
            <button style="width: 33%; border-left: 5px white solid;" @click="selectPreLogged()">Select Pre Logged</button>
            <button style="width: 33%; border-left: 5px white solid;" @click="selectDead()">Dead Run</button>
        </div>
        <div v-for="Route in filteredRoutes" :key="Route.id" class="option">
            <button @click="selectRoute(Route)">{{ Route.route_num }} | {{ Route.inbound_destination }} | {{
                Route.outbound_destination }}</button>
        </div>
    </div>
    <div id="fade"
        style="display: none; position: fixed;top: 0;left: 0;right: 0;border: 0;background: #000000d1;width: 100%;height: 100%;/*! z-index: ; */">
        <button class="Close" @click="close()" style="padding: 2.55% 5%;">X</button>
    </div>
    <div class="popup"
        style="display: none; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); background: white; width: 50vw; height: 20vh; padding: 20px; border-radius: 5px; box-shadow: 0 2px 10px rgba(0,0,0,0.2);">
        <button class="button2 inOutBT">INBOUND to {{ this.stopArray }}</button><br>
        <button class="button1 inOutBT">OUTBOUND to {{ this.stop2Array }}</button>
    </div>
    <div class="popup2"
        style="display: none; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); background: white; width: 50vw; height: 20vh; padding: 20px; border-radius: 5px; box-shadow: 0 2px 10px rgba(0,0,0,0.2);">
        <label for="">Select Terminus</label>
        <select style="width: 100%;border: 0;height: 20%;" v-model="selectedEndDestination">
            <option v-for="(destination, index) in endDestinations" :key="index" :value="destination">
                {{ destination }}
            </option>
        </select>
        <button class="button4 inOutBT">SET</button>
    </div>
    <div class="popup3"
        style="display: none; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); background: white; width: 50vw; height: 20vh; padding: 20px; border-radius: 5px; box-shadow: 0 2px 10px rgba(0,0,0,0.2);">
        <label for="startTime">Start Time</label><br>
        <input type="time" id="startTime" v-model="startTime" data-tempmail="17613"
            style="border: 0;width: 100%;text-align: center;height: 7.5vh;font-size: 2vh;"><br>
        <button style="border-right: 5px solid white;" class="button3 inOutBT">SET</button><button
            style="border-left: 5px solid white;" class="button3 inOutBT" @click="dontLog()">DON'T LOG</button>
    </div>
    <div class="DeadPopup" style="display: none; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); background: white; width: 50vw; height: 10vh; padding: 20px; border-radius: 5px; box-shadow: 0 2px 10px rgba(0,0,0,0.2);">
        <input type="text" name="DeadRunName" id="DeadRunName" placeholder="Dead Run To: ">
        <button style="height: 100%;" class="button1 inOutBT" @click="startDeadRun">SET</button>
    </div>
</template>

<style>
.button3.inOutBT {
    display: inline-block;
    width: 50%;
}

.inOutBT {
    width: 100%;
    height: 50%;
}
</style>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            startTime: '',
            username: '',
            routes: [],
            filteredRoutes: [],
            routeStops: [],
            stopArray: 'test',
            stop2Array: '',
            selectedEndDestination: '', // Variable for storing selected end destination
            endDestinations: [], // Array for storing split destinations
            vehicle: localStorage.getItem('selectedVehicle'),
        };
    },
    mounted() {
        const selectedCompany = localStorage.getItem('selectedCompany');
        const storedRoutes = localStorage.getItem('routes');

        if (storedRoutes) {
            try {
                this.Routes = JSON.parse(storedRoutes); // Parse the stored Routes

                // Sort the routes by Route.route_num
                this.Routes.sort((a, b) => {
                    return a.route_num.localeCompare(b.route_num, undefined, { numeric: true, sensitivity: 'base' });
                });

                this.filterRoutes(selectedCompany);
            } catch (error) {
                console.error('Failed to parse fleets from localStorage:', error);
                this.Routes = []; // Fallback to an empty array
            }
        } else {
            console.error('No fleets found in localStorage');
            this.Routes = [];
        }

        this.username = localStorage.getItem('username') || 'Guest'; // Default to 'Guest' if no username is found
    },
    watch: {
        // Watch the selectedEndDestination and update localStorage when it changes
        selectedEndDestination(newValue) {
            // Store the selected destination in localStorage
            localStorage.setItem('selectedEndDestination', newValue);
        }
    },

    methods: {
        submitTrip() {
            const session_key = localStorage.getItem('session_key');
            localStorage.setItem('currentIndexStop', 1);
            const dontLog = localStorage.getItem('dontLog') === 'true'; // ensure boolean

            console.log('Dead status:', this.dead);

            if (dontLog) {
                this.$router.push({ path: `/loadTicketData` });
                return;
            }

            const currentDate = new Date();
            const vehicleId = localStorage.getItem('selectedVehicle');
            let routeId = localStorage.getItem('selectedRoute');
            let routeNumber = localStorage.getItem('selectedRouteRouteNum');
            let endDestination = localStorage.getItem('selectedEndDestination');
            let startTime = localStorage.getItem('startTime') || '';
            const isInbound = JSON.parse(localStorage.getItem('INBOUND') || 'false');

            // Normalize routeId and vehicleId to integers or null
            routeId = routeId && routeId !== 'undefined' ? parseInt(routeId) : null;
            const vehicleIdNum = vehicleId && vehicleId !== 'undefined' ? parseInt(vehicleId) : null;

            // Determine current stop
            let currentStop = 'dead';
            if (!this.dead) {
                currentStop = isInbound
                    ? localStorage.getItem('selectedRouteStop1')
                    : localStorage.getItem('selectedRouteStop2');
            }

            // Guard against literal 'undefined' and empty values before using
            if (!currentStop || currentStop === 'undefined') {
                currentStop = '';
            }

            // Use first line of stop if multi-line
            const activeStop = currentStop ? currentStop.split('\r\n')[0] : '';
            localStorage.setItem('activeRouteStop', activeStop);

            // Prepare trip date-time
            const tripDateTime = this.dead
                ? currentDate.toISOString()
                : `${currentDate.toISOString().split('T')[0]} ${startTime}`;

            const data = {
                session_key,
                trip_date_time: tripDateTime,
                route_number: routeNumber || 'dead',
                outbound_destination: endDestination || '',
                vehicle_id: vehicleIdNum,
                route_id: routeId,
                InBound: isInbound,
                current_stop: activeStop
            };

            console.log('Trip data to submit:', data);

            // Submit trip via axios
            axios.post('https://www.mybustimes.cc/api/trips/create/', data)
                .then(response => {
                    console.log('Trip submitted successfully:', response.data);
                    if (response.data.trip_id) {
                        localStorage.setItem('TripID', response.data.trip_id);
                    }
                    this.$router.push({ path: `/loadTicketData` });
                })
                .catch(error => {
                    console.error('Error submitting trip:', error);
                });
        },
        selectTicket() {
            localStorage.setItem('dontLog', true);
            this.$router.push({ path: '/loadTicketData' });
        },
        selectPreLogged() {
            this.$router.push({ path: '/PreLogged' });
        },
        selectDead() {
            const popup3 = document.querySelector('.DeadPopup');
            popup3.style.display = 'block';
            localStorage.setItem('dead', true);
            const dead = true;
            this.dead = dead;
            this.submitTrip();
        },
        close() {
            location.reload();
        },
        filterRoutes(companyCode) {
            console.log('Filtering routes for company:', companyCode);
            if (companyCode) {
                this.filteredRoutes = this.Routes.filter((route) => {
                    return route.route_operators_data?.some(
                        (op) => op.operator_code === companyCode
                    );
                });
            } else {
                console.error('No selected company found in localStorage');
                this.filteredRoutes = [];
            }
        },
        dontLog() {
            this.$router.push({ path: '/loadTicketData' });
            localStorage.setItem('dontLog', true);
        },
        async selectRoute(Route) {
            console.log('Selected route ID:', Route);
            const dead = false;
            this.dead = dead;
            let stopSequenceForward = '';
            let stopSequenceReverse = '';

            // Fetch stops for the selected route and store them (await so storage happens before navigation)
            try {
                const response = await axios.get(`https://www.mybustimes.cc/api/routes/${Route.id}/stops/`);
                const stops = response.data?.stops || [];
                console.log('Route stops:', stops);
                this.routeStops = stops;
                const stopNames = stops
                    .map((item) => item?.stop) 
                    .filter(Boolean);
                stopSequenceForward = stopNames.join('\r\n');
                stopSequenceReverse = [...stopNames].reverse().join('\r\n');
                localStorage.setItem('selectedRouteStops', JSON.stringify(stops));
            } catch (error) {
                console.error('Error fetching route stops:', error);
                // ensure key exists even on failure
                localStorage.setItem('selectedRouteStops', JSON.stringify([]));
            }
            // Split the stop and destination values into arrays
            const stop1Array = Route.inbound_destination;
            const stop2Array = Route.outbound_destination;
            const destination = Route.destination;
            const destination2 = Route.destination2;
            const destinationArray = destination === 'null' || !destination ? [] : destination.split(' - ').filter(item => item !== 'null');
            const destination2Array = destination2 === 'null' || !destination2 ? [] : destination2.split(' - ').filter(item => item !== 'null');

            this.stopArray = stop1Array;
            this.stop2Array = stop2Array;

            this.endDestinations = [stop1Array, stop2Array, ...destinationArray, ...destination2Array];

            // Save the selected route information in localStorage (sanitize undefined/null)
            console.log('Selected route ID:', Route.id);
            localStorage.setItem('selectedRoute', Route.id);
            localStorage.setItem('selectedRouteStart', Route.inbound_destination || '');
            localStorage.setItem('selectedRouteEnd', Route.outbound_destination || '');
            localStorage.setItem('selectedRouteStop1', stopSequenceForward || Route.stop || '');
            localStorage.setItem('selectedRouteStop2', stopSequenceReverse || Route.stop2 || '');
            localStorage.setItem('selectedRouteRouteNum', Route.route_num || '');
            localStorage.setItem('selectedRouteDest1', Route.destination || '');
            localStorage.setItem('selectedRouteDest2', Route.destination2 || '');
            localStorage.setItem('selectedRouteName', Route.route_name || '');
            console.log('Saved selectedRouteStop1:', localStorage.getItem('selectedRouteStop1'));
            console.log('Saved selectedRouteStop2:', localStorage.getItem('selectedRouteStop2'));

            // Show the popup
            const popup = document.querySelector('.popup');
            popup.style.display = 'block';

            const fade = document.getElementById('fade');
            fade.style.display = 'block';

            // Wait for user action
            const button1 = document.querySelector('.button1'); // Confirm button
            const button2 = document.querySelector('.button2'); // Cancel button
            const button3 = document.querySelector('.button3'); // Cancel button
            const button4 = document.querySelector('.button4'); // Cancel button

            const handleButton3Click = () => {
                button3.removeEventListener('click', handleButton3Click);
                localStorage.setItem('startTime', this.startTime);  // Use this.startTime instead of time.value
                console.log(this.startTime)
                this.submitTrip();
            };

            const handleButton4Click = () => {
                button3.addEventListener('click', handleButton3Click);
                const popup3 = document.querySelector('.popup3');
                popup3.style.display = 'block';
                const popup2 = document.querySelector('.popup2');
                popup2.style.display = 'none';
                button4.removeEventListener('click', handleButton4Click);
            };

            const handleButtonClick = (event) => {
                const button = event.target;
                if (button.classList.contains('button1')) {
                    localStorage.setItem('INBOUND', true);
                    const popup2 = document.querySelector('.popup2');
                    popup2.style.display = 'block';
                    this.selectedEndDestination = this.stop2Array;
                    localStorage.setItem('selectedRouteDestEnd', Route.destination);
                    localStorage.setItem('selectedRouteDestStart', Route.destination2);
                    button4.addEventListener('click', handleButton4Click);
                } else if (button.classList.contains('button2')) {
                    localStorage.setItem('INBOUND', false);
                    const popup2 = document.querySelector('.popup2');
                    popup2.style.display = 'block';
                    this.selectedEndDestination = this.stopArray;
                    localStorage.setItem('selectedRouteDestStart', Route.destination2);
                    localStorage.setItem('selectedRouteDestEnd', Route.destination);
                    button4.addEventListener('click', handleButton4Click);
                }

                // Hide popup and clean up event listeners
                popup.style.display = 'none';
                button1.removeEventListener('click', handleButtonClick);
                button2.removeEventListener('click', handleButtonClick);
            };

            button1.addEventListener('click', handleButtonClick);
            button2.addEventListener('click', handleButtonClick);
        },
        logOff() {
            // Redirect the user to a login page or home page (if needed)
            this.$router.push({ path: '/vehicleSelect' });
        }
    }
};
</script>
